import React from "react";

// REACT VIS
import "react-vis/dist/style.css";
import {
  XYPlot,
  LineSeries,
  VerticalGridLines,
  HorizontalGridLines,
  YAxis,
  XAxis,
  MarkSeries,
  VerticalBarSeries,
} from "react-vis";

function Graph() {
  const data = [
    { x: 0, y: 8 },
    { x: 1, y: 5 },
    { x: 2, y: 4 },
    { x: 3, y: 9 },
    { x: 4, y: 1 },
    { x: 5, y: 7 },
    { x: 6, y: 6 },
    { x: 7, y: 3 },
    { x: 8, y: 2 },
    { x: 9, y: 0 },
  ];

  return (
    <>
      <h1>Using React-Vis for graphs {"&"} chart </h1>
      <div>Graph, avialable soon...</div>

      <h3>REACT-vis 1</h3>
      <XYPlot height={300} width={300}>
        <LineSeries data={data} />
      </XYPlot>

      <h3>REACT-vis 2</h3>
      <XYPlot height={300} width={300}>
        <LineSeries data={data} />
        <VerticalGridLines />
        <HorizontalGridLines />
        <XAxis />
        <YAxis />
      </XYPlot>

      <h3>REACT-vis 3</h3>
      <XYPlot height={200} width={200}>
        <VerticalBarSeries data={data} />
      </XYPlot>
      <XYPlot height={200} width={200}>
        <LineSeries data={data} />
      </XYPlot>
      <XYPlot height={200} width={200}>
        <MarkSeries data={data} />
      </XYPlot>
    </>
  );
}

export default Graph;
